import { ca } from '@cian/analytics';
import { createDeveloperGaProduct, createDeveloperProduct, createLabel } from '../../utils';
import { createGaUser } from '../../utils/analytics/createGaUser';
import { IUser } from '../../types/user/user';
import { IDeveloper } from '../../types/developer/developer';
import { EPromoType } from '../../types/newBuldings/promo';

export function trackOpenDiscount(discountType: EPromoType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_promotions_builder',
    label: discountType,
    useLastProducts: true,
  });
}

export function trackShowPhone(discountId: number, discountType: EPromoType) {
  return (developer: IDeveloper, user: IUser) => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Phones',
      action: 'Open_card_promotions',
      label: createLabel(developer.id),
      user: createGaUser(user),
      products: [
        {
          ...createDeveloperProduct({ id: developer.id }),
          ...createDeveloperGaProduct(developer.id, developer.name),
          extra: {
            label: discountType,
            promotion_id: discountId,
          },
        },
      ],
    });
  };
}
